import './sidepanel.css'
import { useContext } from 'react'
import { ThemeContext } from '../context';
export default function Bcmp(props) {
    const theme = useContext(ThemeContext)
  return (
    <div className='f-ele'>
        <div className={`icondiv ${props.class}`}>
            <div className={`f-icon-${theme.currentTheme}`}>
                {props.icon}
            </div>
        </div>
        <div className={`f-name-${theme.currentTheme} ${props.class}`}>{props.name}</div>
        <div className={`f-halfround ${props.class}`}></div>
    </div>
  )
}
